module.exports = __webpack_public_path__ + "static/img/99036D_3_R_20190716_LC.7fd1b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/99036D_3_R_20190716_LC.png
// module id = 3Plp
// module chunks = 0